module.exports = __webpack_public_path__ + "static/spainmap-d00b2e30ff38c28c67e00bbc8fe8b3dc.svg";